import { cn } from "@/lib/utils";
import { forwardRef } from "react";

/** 모달 본문 컨테이너. stack.tsx 와 분리한 이유: 개별 모달이 이걸 import 하는데 stack 이 그 모달을 렌더하면 순환이 된다. */
const ModalWrapper = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "fixed left-[50%] top-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
      className,
    )}
    {...props}
  >
    {children}
  </div>
));

ModalWrapper.displayName = "ModalWrapper";

export { ModalWrapper };
